import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const FieldStaffPermissionsApi = createApi({
	reducerPath: "FieldStaffPermissions",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		addFieldStaffPermission: builder.mutation({
			query: (val) => ({
				url: `/fieldStaff/permissions`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deleteFieldStaffPermission: builder.mutation({
			query: (val) => ({
				url: `fieldStaff/permissions`,
				method: "DELETE",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
	}),
});

export const {
	useAddFieldStaffPermissionMutation,
	useDeleteFieldStaffPermissionMutation,
} = FieldStaffPermissionsApi;
